import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { URL_MAP } from '../../shared/urlMap';
import { constantsStatistic } from '../util/constants-statistic';

@Injectable({ providedIn: 'root' })
export class RetefuenteService {

    private baseUrl = URL_MAP.RETENTION.URL;

  private headers = new HttpHeaders({
    'Content-Type': 'application/json'
  });

  getYears(): Observable<any> {
    const u = `${URL_MAP.RETENTION.YEAR.URL}${URL_MAP.RETENTION.YEAR.SYSTEM}/${URL_MAP.RETENTION.YEAR.TOKEN}`;
    return this.http.get(u);
  }

  buildPdfUrl(data: { document: string; year: number; fullName: string }): string {
    const nombre = encodeURIComponent(data.fullName || '');
    return `${this.baseUrl}&ID=${data.document}&ANIO=${data.year}&NOMBRE=${nombre}`;
  }
  
  downloadPdfBlob(url: string): Observable<Blob> {
    return this.http.get(url, { responseType: 'blob' });
  }

  constructor(private http: HttpClient) {}
}